import React from 'react';
import HelpIcon from './HelpIcon';

const TextareaInput = ({
  label,
  name,
  register,
  errors,
  validation,
  rows = 4,
  align = 'left',
  sx = {},
  showRequiredIndicator = false,
  helptext
}) => (
  <div className="form-group" style={{ textAlign: align }}>
    <label htmlFor={name}>
      {label}
      {validation?.required && showRequiredIndicator && <span className="required-indicator">*</span>}
      <HelpIcon helptext={helptext} />
    </label>
    <textarea
      id={name}
      rows={rows}
      style={sx}
      {...register(name, validation)}
    />
    {errors[name] && <p style={{ color: 'red' }}>{errors[name].message}</p>}
  </div>
);

export default TextareaInput;
